export const DEFAULT_LANGUAGE = 'id';
export const FALLBACK_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'id'];
